export { default as RestrictionMessage } from './RestrictionMessage';
